import { useQuery } from '@tanstack/react-query'

import { QuestionProps } from '@components/QuestionAndChoices'
import { getQuestionById } from '@lib/query/queryFunction'

export const useQuestion = (id: number) => {
  return useQuery<QuestionProps>([`question${id}`], getQuestionById(id))
}
